const defaultEdgeColor = 'gray';
const defaultEdgeMarkerSize = 14;

const sanitizeNodeDataForDomain = (data = {}) => {
    const {
        showHandle,
        highlighted,
        activeSourceHandleId,
        activeTargetHandleId,
        ...domainData
    } = data || {};

    return domainData;
};

const sanitizeNodeForDomain = (node = {}) => {
    const {
        selected,
        dragging,
        resizing,
        measured,
        width,
        height,
        positionAbsolute,
        draggable,
        selectable,
        deletable,
        zIndex,
        ...domainNode
    } = node || {};

    return {
        ...domainNode,
        data: sanitizeNodeDataForDomain(domainNode.data || {})
    };
};

const sanitizeEdgeStyleForDomain = (style = {}, sourceType) => {
    const {
        filter,
        opacity,
        zIndex,
        transition,
        ...baseStyle
    } = style || {};

    // const shouldUseDash = sourceType === 'subject' || baseStyle.strokeDasharray === '5,5';

    const nextStyle = {
        ...baseStyle,
        stroke: defaultEdgeColor,
        strokeWidth: 2,
    };

    // if (shouldUseDash) {
    //     nextStyle.strokeDasharray = '5,5';
    // } else {
    //     delete nextStyle.strokeDasharray;
    // }

    if (nextStyle.strokeDasharray) {
        delete nextStyle.strokeDasharray;
    }

    return nextStyle;
};

const sanitizeEdgeForDomain = (edge = {}, nodeTypeById = new Map()) => {
    const {
        selected,
        reconnectable,
        selectable,
        deletable,
        updatable,
        focusable,
        ...domainEdge
    } = edge || {};

    const sourceType = nodeTypeById.get(domainEdge.source);
    const style = sanitizeEdgeStyleForDomain(domainEdge.style || {}, sourceType);

    return {
        ...domainEdge,
        style,
        markerEnd: domainEdge.markerEnd
            ? {
                ...domainEdge.markerEnd,
                color: defaultEdgeColor,
                width: defaultEdgeMarkerSize,
                height: defaultEdgeMarkerSize,
            }
            : domainEdge.markerEnd
    };
};

export const createRegulatoryDomainDiagram = (nodes = [], edges = []) => {
    const safeNodes = Array.isArray(nodes) ? nodes : [];
    const safeEdges = Array.isArray(edges) ? edges : [];

    const domainNodes = safeNodes.map(sanitizeNodeForDomain);
    const nodeTypeById = new Map(domainNodes.map((node) => [node.id, node.type]));
    const domainEdges = safeEdges.map((edge) => sanitizeEdgeForDomain(edge, nodeTypeById));

    return {
        nodes: domainNodes,
        edges: domainEdges
    };
};

export const createRegulatoryFlowCompareSnapshot = (flow = {}) => {
    const safeFlow = flow || {};
    return createRegulatoryDomainDiagram(safeFlow.nodes || [], safeFlow.edges || []);
};

export const toRegulatoryDomainFile = (file) => {
    if (!file || typeof file !== 'object' || !file.diagram) {
        return file;
    }

    const persistedDiagram = createRegulatoryDomainDiagram(file.diagram.nodes || [], file.diagram.edges || []);

    return {
        ...file,
        diagram: {
            ...file.diagram,
            nodes: persistedDiagram.nodes,
            edges: persistedDiagram.edges
        }
    };
};
